import type React from 'react';

/**
 * Posicionamento compartilhado dos tours (PageTour e TourOverlay).
 * Garante que o balão com "Próximo"/"Concluir" fique SEMPRE dentro da tela,
 * mesmo quando o elemento destacado é maior que a viewport (ex.: painel de /settings no celular).
 */
const MARGIN = 16;
const GAP = 14;

type RectLike = { top: number; left: number; width: number; height: number };

/** Rola a página até o elemento: centraliza se couber, senão alinha o topo dele no topo da tela. */
export const scrollTourTarget = (el: Element | null) => {
  if (!el) return;
  const r = el.getBoundingClientRect();
  const fits = r.height < window.innerHeight * 0.55;
  (el as HTMLElement).scrollIntoView({ behavior: 'smooth', block: fits ? 'center' : 'start' });
};

/** Estilo fixed do balão: abaixo do destaque, acima, ou preso ao rodapé da tela como último recurso. */
export const tourPopoverStyle = (rect: RectLike | null, width: number, approxHeight = 230): React.CSSProperties => {
  const style: React.CSSProperties = { position: 'fixed', width };
  if (!rect) return { ...style, left: '50%', top: '50%', transform: 'translate(-50%, -50%)' };

  const vh = window.innerHeight;
  const vw = window.innerWidth;
  style.left = Math.max(MARGIN, Math.min(rect.left + rect.width / 2 - width / 2, vw - width - MARGIN));

  const bottomEdge = rect.top + rect.height;
  if (bottomEdge + GAP + approxHeight <= vh - MARGIN && bottomEdge + GAP >= MARGIN) {
    style.top = bottomEdge + GAP;
  } else if (rect.top - GAP - approxHeight >= MARGIN && rect.top - GAP <= vh - MARGIN) {
    style.bottom = vh - rect.top + GAP;
  } else {
    // destaque maior que a tela ou fora dela: balão fixo no rodapé, sempre visível
    style.bottom = MARGIN;
  }
  style.maxHeight = vh - MARGIN * 2;
  style.overflowY = 'auto';
  return style;
};
